"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.putRequestOptions = void 0;
// TODO -- common header names & values to checkout-utils
const putRequestOptions = exports.putRequestOptions = {
  // eslint-disable-next-line @typescript-eslint/naming-convention -- predefined HTTP header name
  headers: {
    'Content-Type': 'application/json'
  },
  method: 'PUT'
};